// extracted by mini-css-extract-plugin
export default {"special-dates-container__label-text":"special-dates-container__label-text--x5FqQ","specialDatesContainerLabelText":"special-dates-container__label-text--x5FqQ"};